{{ amount() | number: '1.2-2' }} {{ currency() }}
